module.exports = __webpack_public_path__ + "static/media/annaluke_engagement-17-min.2606f22d.jpg";